
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  UpdateReferrerRateRequest,
} from '../models';
import {
    UpdateReferrerRateRequestFromJSON,
    UpdateReferrerRateRequestToJSON,
} from '../models';

export interface UpdateRateRequest {
    submissionId: string;
    updateReferrerRateRequest: UpdateReferrerRateRequest;
}

/**
 * 
 */
export class EligibilityReferrerApi extends runtime.BaseAPI {

    /**
     * Update referral rate for referrer if referral becomes an opportunity
          */
    async updateRateRaw(requestParameters: UpdateRateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateRate().'
            );
        }

        if (requestParameters['updateReferrerRateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferrerRateRequest',
                'Required parameter "updateReferrerRateRequest" was null or undefined when calling updateRate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/{submissionId}/referrer/rates`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferrerRateRequestToJSON(requestParameters['updateReferrerRateRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update referral rate for referrer if referral becomes an opportunity
          */
    async updateRate(requestParameters: UpdateRateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateRateRaw(requestParameters, initOverrides);
    }

}
